<script lang="ts">
    // import vm from '@journeys/Journeys.viewmodel'
    // assets
    import { InfoSVG, WarningSVG, ErrorSVG, ThinCrossSVG, CheckSVG } from '../../assets/vector/ui/IconsUI';

    // components
    import FluidButton from '../FluidButton.vue';

    // this is mostly for debugging, otherwise components are Anonymous
    const component = {
        name: 'UI_Notification',
    };

    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    // const { toast } = vm

    const props = withDefaults(
        defineProps<{
            type: string;
            message?: {
                head?: string;
                body?: string;
                break?: boolean;
            };
            sizing?: string;
            icon?: string;
            placement?: string;
            allowClose?: boolean;
            closeNote?: (...arg: any) => void;
            childClass?: string;
            inspect?: (...args: any) => any | null;
        }>(),
        {
            sizing: 'regular',
        }
    );

    let icon =
        props.type === 'info' ? InfoSVG : props.type === 'warning' ? WarningSVG : props.type === 'error' ? ErrorSVG : props.type === 'success' && CheckSVG;

    let isStatic: boolean;

    if (!props.placement) isStatic = true;
</script>

<template>
    <div class="notification-wrapper">
        <div class="alert-notification col-gap-sm" :class="`${type} ${placement} ${'size-' + sizing} ${childClass}`" role="alert">
            <component :is="icon" class="m-xxs-t"></component>

            <div class="flex-1">
                <p>
                    <strong v-if="message?.head" v-html="message?.head"></strong>
                    <span class="m-xs-l" v-if="!message?.break" v-html="message?.body"></span>
                    <span class="m-xs-l" v-if="message?.break" v-html="message?.body"></span>
                </p>

                <div v-if="inspect">
                    <FluidButton class="btn btn-sm m-xs-t" :class="'btn-' + props.type" :text="'[Resolve]'" @click.stop="inspect" />
                </div>
            </div>

            <FluidButton
                style="padding: 0"
                :icon="ThinCrossSVG"
                class="btn btn-subtle btn-sm o-60"
                :text="$Resources.CloseBtn"
                iconClasses="notification-close-icon"
                textClasses="sr-only"
                v-if="allowClose"
                @click.stop="closeNote" />
        </div>

        <div class="toast-spacing"></div>
    </div>
</template>

<style lang="less">
    /*
	.notification-wrapper.static .alert-notification {
		width: auto;
	}
    */

    .notification-wrapper p {
        margin-bottom: 0;
    }

    .toast-spacing {
        position: relative;
        min-height: 0.625rem;
    }

    .alert-notification {
        display: flex;
        align-items: start;
        max-width: 30rem;
        padding: 0.625rem;
        // background-color: var(--brand-success-light);
        background-color: hsl(var(--brand-success-hue-sat), calc(var(--brand-success-light) + 50%));
        border-radius: var(--border-radius);
        border-left: 0.3rem solid var(--brand-success);
        width: 100%;
    }

    .alert-notification:where(.success, .warning, .info, .error) svg {
        height: 1rem;
        width: 1rem;
        fill: var(--brand-success);
        pointer-events: none;
    }

    .notification-close-icon {
        stroke: var(--text-color);
        stroke-width: 2;
    }

    .alert-notification.info {
        border-color: var(--brand-info);
        // background-color: var(--brand-info-light);
        background-color: hsl(var(--brand-info-hue-sat), calc(var(--brand-info-light) + 52.5%));
    }

    .alert-notification.warning {
        border-color: var(--brand-warning);
        // background-color: var(--brand-warning-light);
        background-color: hsl(var(--brand-warning-hue-sat), calc(var(--brand-warning-light) + 47.5%));
    }

    .alert-notification.error {
        border-color: var(--brand-danger);
        // background-color: var(--brand-danger-light);
        background-color: hsl(var(--brand-danger-hue-sat), calc(var(--brand-danger-light) + 52.5%));
    }
</style>
